import {focusInputGroups} from "cronus-theme/default/global/js/checkInputGroups";
import {initInputBody} from "cronus-theme/default/global/js/inputfile";
import {TextconstantService} from "dc-services/textconstant.service";
import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";

export async function initRoadshowForms() {
    'use strict';

    await TextconstantService.preloadTextConstants('roadshow');
    const tcs = TextconstantService.getAllTextConstants();

    const TOTAL_STEPS = 5;

    // ── Labels for summary ───────────────────────────────────────────────────
    const FIELD_LABELS = {
        contactCompany:      tcs.roadshow_label_company,
        contactFirstName:    tcs.roadshow_label_firstname,
        contactLastName:     tcs.roadshow_label_lastname,
        contactEmail:        tcs.roadshow_label_email,
        contactPhone:        tcs.roadshow_label_phone,
        projectName:         tcs.roadshow_label_project_name,
        plannedPeriod:       tcs.roadshow_label_planned_period,
        eventType:           tcs.roadshow_label_event_type,
        stopsCount:          tcs.roadshow_label_stops_count,
        countries:           tcs.roadshow_label_countries,
        locationsFixed:      tcs.roadshow_label_locations_fixed,
        stopDuration:        tcs.roadshow_label_stop_duration,
        vehicleType:         tcs.roadshow_label_vehicle_type,
        vehicleSize:         tcs.roadshow_label_vehicle_size,
        indoorOutdoor:       tcs.roadshow_label_indoor_outdoor,
        vehicleNotes:        tcs.roadshow_label_vehicle_notes,
        roadshowGoal:        tcs.roadshow_label_roadshow_goal,
        targetGroup:         tcs.roadshow_label_target_group,
        visitorsPerStop:     tcs.roadshow_label_visitors_per_stop,
        activities:          tcs.roadshow_label_activities,
        brandingExists:      tcs.roadshow_label_branding_exists,
        customBuild:         tcs.roadshow_label_custom_build,
        techNeeds:           tcs.roadshow_label_tech_needs,
        furnitureNeeded:     tcs.roadshow_label_furniture_needed,
        staffNeeded:         tcs.roadshow_label_staff_needed,
        projectMgmt:         tcs.roadshow_label_project_mgmt,
        fullService:         tcs.roadshow_label_full_service,
        routePlanning:       tcs.roadshow_label_route_planning,
        transportOrg:        tcs.roadshow_label_transport_org,
        storageBetween:      tcs.roadshow_label_storage_between,
        permitsNeeded:       tcs.roadshow_label_permits_needed,
        cateringNeeded:      tcs.roadshow_label_catering_needed,
        cateringType:        tcs.roadshow_label_catering_type,
        cateringPersons:     tcs.roadshow_label_catering_persons,
        vision:              tcs.roadshow_label_vision,
        pastExperience:      tcs.roadshow_label_past_experience,
        references:          tcs.roadshow_label_references,
        pastLikes:           tcs.roadshow_label_past_likes,
        pastDislikes:        tcs.roadshow_label_past_dislikes,
        budgetRange:         tcs.roadshow_label_budget_range,
        budgetConstraints:   tcs.roadshow_label_budget_constraints,
        offerDeadline:       tcs.roadshow_label_offer_deadline,
        specialRequirements: tcs.roadshow_label_special_requirements,
        openPoints:          tcs.roadshow_label_open_points,
    };

    const STEP_TITLES = [
        tcs.roadshow_step1_title,
        tcs.roadshow_step2_title,
        tcs.roadshow_step3_title,
        tcs.roadshow_step4_title,
        tcs.roadshow_step6_title,
    ];

    // ── Init ─────────────────────────────────────────────────────────────────
    document.querySelectorAll('.js-roadshowForm').forEach(function (wrapper) {
        initRoadshowForm(wrapper);
        wrapper.querySelectorAll('.js-rsTagInput').forEach(function (el) { initTagInput(el); });
        focusInputGroups(wrapper.querySelectorAll('.inputGroup input, .inputGroup select, .inputGroup textarea'));
        initInputBody(wrapper.querySelectorAll('.fileBody'));
    });

    // ── Tag Input (Freitext) ──────────────────────────────────────────────────
    function initTagInput(container) {
        const input        = container.querySelector('.js-rsTagInputField');
        const hiddenInput  = container.querySelector('.js-rsTagValue');
        const tagsContainer = container.querySelector('.js-rsTagList');

        if (!input) return;

        const selected = [];

        function renderTags() {
            tagsContainer.innerHTML = selected.map(function (val, i) {
                return `<button type="button" class="roadshowForm__locationTag" data-index="${i}" aria-label="${tcs.roadshow_label_remove || 'Entfernen'}: ${val}">${val} <span aria-hidden="true">×</span></button>`;
            }).join('');
            hiddenInput.value = selected.join(', ');

            tagsContainer.querySelectorAll('.roadshowForm__locationTag').forEach(function (btn) {
                btn.addEventListener('click', function () {
                    selected.splice(Number(btn.dataset.index), 1);
                    renderTags();
                });
            });
        }

        function addTag(value) {
            value = value.trim();
            if (!value || selected.includes(value)) return;
            selected.push(value);
            renderTags();
            input.value = '';
        }

        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ',') {
                e.preventDefault();
                addTag(input.value);
            }
        });

        input.addEventListener('blur', function () {
            addTag(input.value);
        });
    }

    function initRoadshowForm(wrapper) {
        const form        = wrapper.querySelector('.js-rsForm');
        const progressFill = wrapper.querySelector('.js-rsProgressFill');
        const stepLabel   = wrapper.querySelector('.js-rsStepLabel');
        const currentStepEl = wrapper.querySelector('.js-rsCurrentStep');
        const btnPrev     = wrapper.querySelector('.js-rsPrev');
        const btnNext     = wrapper.querySelector('.js-rsNext');
        const btnSubmit   = wrapper.querySelector('.js-rsSubmit');
        const errorBox    = wrapper.querySelector('.js-rsError');
        const successBox  = wrapper.querySelector('.js-rsSuccess');
        const summaryContent = wrapper.querySelector('.js-rsSummaryContent');
        const stepDots    = wrapper.querySelectorAll('.roadshowForm__stepDot');

        const HS_PORTAL_ID = wrapper.dataset.hsPortalId || '8491699';
        const HS_FORM_ID   = wrapper.dataset.hsFormId   || '51051434-b2dd-4780-b616-2a61f0646059';
        const HS_API_URL   = `https://api.hsforms.com/submissions/v3/integration/submit/${HS_PORTAL_ID}/${HS_FORM_ID}`;

        let currentStep = 1;
        let formDirty = false;

        function onBeforeUnload(e) {
            e.preventDefault();
            e.returnValue = '';
        }

        form.addEventListener('input', function () {
            if (!formDirty) {
                formDirty = true;
                window.addEventListener('beforeunload', onBeforeUnload);
            }
        }, { once: false });

        // Flatpickr – Range (Geplanter Zeitraum)
        const rangeInput = wrapper.querySelector('.js-rsDateRange');
        if (rangeInput) {
            flatpickr(rangeInput, {
                mode: 'range',
                locale: German,
                dateFormat: 'd.m.Y',
                minDate: 'today',
                disableMobile: true,
                onReady: function(_, __, fp) {
                    fp.calendarContainer.classList.add('roadshowForm__flatpickr');
                },
                onChange: function() {
                    rangeInput.dispatchEvent(new Event('input', { bubbles: true }));
                },
            });
        }

        // Flatpickr – Single (Deadline)
        const deadlineInput = wrapper.querySelector('.js-rsDateSingle');
        if (deadlineInput) {
            flatpickr(deadlineInput, {
                locale: German,
                dateFormat: 'd.m.Y',
                minDate: 'today',
                disableMobile: true,
                onReady: function(_, __, fp) {
                    fp.calendarContainer.classList.add('roadshowForm__flatpickr');
                },
                onChange: function() {
                    deadlineInput.dispatchEvent(new Event('input', { bubbles: true }));
                },
            });
        }

        // Event type toggle (Roadshow / Einzelevent)
        function updateEventTypeUI() {
            const selected = wrapper.querySelector('.js-rs-event-type:checked');
            const isRoadshow = !selected || selected.value === 'roadshow';
            wrapper.querySelectorAll('.js-rs-stopsField').forEach(function (el) {
                el.style.display = isRoadshow ? '' : 'none';
            });
            const stopsInput = wrapper.querySelector('.js-rs-stopsCount');
            if (stopsInput) {
                if (isRoadshow) {
                    stopsInput.classList.add('js-rs-required');
                } else {
                    stopsInput.classList.remove('js-rs-required');
                    stopsInput.classList.remove('is-invalid');
                    stopsInput.value = '';
                }
            }
            const cateringPersonsLabel = wrapper.querySelector('[for="rs-cateringPersons"]');
            if (cateringPersonsLabel) {
                cateringPersonsLabel.textContent = isRoadshow
                    ? tcs.roadshow_label_catering_persons
                    : tcs.roadshow_label_catering_persons_single;
            }
        }
        wrapper.querySelectorAll('.js-rs-event-type').forEach(function (radio) {
            radio.addEventListener('change', updateEventTypeUI);
        });
        updateEventTypeUI();

        // Catering conditional
        wrapper.querySelectorAll('.js-rs-catering-toggle').forEach(function (radio) {
            radio.addEventListener('change', function () {
                const cateringFields = wrapper.querySelector('.js-rs-cateringFields');
                if (cateringFields) {
                    cateringFields.style.display = this.value === 'yes' ? 'block' : 'none';
                }
            });
        });

        // Navigation
        btnNext.addEventListener('click', function () {
            if (!validateStep(currentStep)) return;
            if (currentStep < TOTAL_STEPS) {
                goToStep(currentStep + 1);
            }
        });

        btnPrev.addEventListener('click', function () {
            if (currentStep > 1) {
                goToStep(currentStep - 1);
            }
        });


        // Enter → Weiter-Button triggern (außer auf Textarea, Autocomplete und Tag-Inputs)
        form.addEventListener('keydown', function (e) {
            if (e.key !== 'Enter') return;
            if (e.target.tagName === 'TEXTAREA') return;
            if (e.target.classList.contains('js-rsLocationSearch')) return;
            if (e.target.classList.contains('js-rsTagInputField')) return;
            e.preventDefault();
            if (currentStep < TOTAL_STEPS) {
                btnNext.click();
            }
        });

        // Submit
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            if (!validateStep(currentStep)) return;
            submitForm();
        });

        function goToStep(step) {
            const allSteps = wrapper.querySelectorAll('.roadshowForm__step');

            allSteps.forEach(function (el) { el.classList.remove('is-active', 'is-leaving'); });

            if (step === TOTAL_STEPS) {
                buildSummary();
            }

            allSteps[step - 1].classList.add('is-active');

            currentStep = step;
            updateNav();
            updateProgress();
            clearError();

            wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });

            const firstInput = allSteps[step - 1].querySelector('input:not([type=hidden]):not([type=radio]):not([type=checkbox]), textarea');
            if (firstInput) firstInput.focus({ preventScroll: true });
        }

        function updateNav() {
            btnPrev.style.display  = currentStep > 1 ? 'inline-flex' : 'none';
            btnNext.style.display  = currentStep < TOTAL_STEPS ? 'inline-flex' : 'none';
            btnSubmit.style.display = currentStep === TOTAL_STEPS ? 'inline-flex' : 'none';

            if (currentStepEl) currentStepEl.textContent = currentStep;

            stepDots.forEach(function (dot, i) {
                dot.classList.toggle('is-active', i + 1 === currentStep);
                dot.classList.toggle('is-done', i + 1 < currentStep);
            });
        }

        function updateProgress() {
            const pct = ((currentStep - 1) / (TOTAL_STEPS - 1)) * 100;
            if (progressFill) progressFill.style.width = pct + '%';
        }

        // ── Validation ───────────────────────────────────────────────────────
        function validateStep(step) {
            clearError();
            const stepEl = wrapper.querySelector('.roadshowForm__step[data-step="' + step + '"]');
            if (!stepEl) return true;

            let valid = true;
            let firstInvalid = null;

            // Required text/email inputs
            stepEl.querySelectorAll('.js-rs-required').forEach(function (field) {
                let invalid = false;
                if (field.type === 'checkbox') {
                    if (!field.checked) invalid = true;
                } else {
                    if (!field.value.trim()) invalid = true;
                }
                if (invalid) {
                    markInvalid(field);
                    valid = false;
                    if (!firstInvalid) firstInvalid = field;
                }
            });

            // Email format
            stepEl.querySelectorAll('.js-rs-email').forEach(function (field) {
                if (field.value.trim() && !isValidEmail(field.value.trim())) {
                    markInvalid(field);
                    valid = false;
                    if (!firstInvalid) firstInvalid = field;
                }
            });

            if (!valid) {
                showError(tcs.roadshow_error_required || 'Bitte fülle alle Pflichtfelder aus.');
                if (firstInvalid) {
                    firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    firstInvalid.focus({ preventScroll: true });
                }
            }

            return valid;
        }

        function markInvalid(field) {
            field.classList.add('is-invalid');
            field.addEventListener('input', function () {
                field.classList.remove('is-invalid');
            }, { once: true });
        }

        function isValidEmail(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        }

        // ── Summary ──────────────────────────────────────────────────────────
        const VALUE_LABELS = {
            roadshow:               'Roadshow',
            single_event:           tcs.roadshow_label_single_event,
            yes:                    tcs.roadshow_label_yes,
            no:                     tcs.roadshow_label_no,
            partial:                tcs.roadshow_label_partial,
            both:                   tcs.roadshow_label_both,
            indoor:                 tcs.roadshow_label_indoor,
            outdoor:                tcs.roadshow_label_outdoor,
            driver:                 tcs.roadshow_staff_driver,
            promoter:               tcs.roadshow_staff_promoter,
            technician:             tcs.roadshow_staff_technician,
            all:                    tcs.roadshow_staff_all,
            none:                   tcs.roadshow_label_none,
            unknown:                tcs.roadshow_label_unknown,
            trailer:                tcs.roadshow_vehicle_trailer,
            truck:                  tcs.roadshow_vehicle_truck,
            container:              tcs.roadshow_vehicle_container,
            other:                  tcs.roadshow_label_other,
            product_presentation:   tcs.roadshow_goal_product_presentation,
            lead_generation:        tcs.roadshow_goal_lead_generation,
            branding:               tcs.roadshow_goal_branding,
            sales:                  tcs.roadshow_goal_sales,
            sampling:               tcs.roadshow_goal_sampling,
            presentation:           tcs.roadshow_activity_presentation,
            gaming:                 tcs.roadshow_activity_gaming,
            experience:             tcs.roadshow_activity_experience,
            screens:                tcs.roadshow_tech_screens,
            sound:                  tcs.roadshow_tech_sound,
            lighting:               tcs.roadshow_tech_lighting,
            vr_ar:                  tcs.roadshow_tech_vr_ar,
        };

        function translateValue(val) {
            return VALUE_LABELS[val] || val;
        }

        function buildSummary() {
            if (!summaryContent) return;

            const data = collectFormData();
            let html = '';

            for (let s = 1; s <= TOTAL_STEPS - 1; s++) {
                const stepKey  = 'step' + s;
                const stepData = data[stepKey] || {};
                const entries  = Object.entries(stepData).filter(function ([, v]) {
                    if (Array.isArray(v)) return v.length > 0;
                    return v !== '' && v !== null && v !== undefined;
                });

                if (!entries.length) continue;

                html += '<div class="roadshowForm__summarySection">';
                html += '<div class="roadshowForm__summarySectionTitle">' + escHtml(STEP_TITLES[s - 1]) + '</div>';
                html += '<dl class="roadshowForm__summaryList">';

                entries.forEach(function ([key, val]) {
                    const label = FIELD_LABELS[key] || key;
                    let value = Array.isArray(val)
                        ? val.map(translateValue).join(', ')
                        : translateValue(String(val));
                    html += '<dt>' + escHtml(label) + '</dt><dd>' + escHtml(value) + '</dd>';
                });

                html += '</dl></div>';
            }

            summaryContent.innerHTML = html || '<p>' + escHtml(tcs.roadshow_label_no_entries || 'Keine Angaben vorhanden.') + '</p>';
        }

        // ── Data collection ──────────────────────────────────────────────────
        function collectFormData() {
            const data = {};

            for (let s = 1; s <= TOTAL_STEPS; s++) {
                const stepEl  = wrapper.querySelector('.roadshowForm__step[data-step="' + s + '"]');
                const stepKey = 'step' + s;
                data[stepKey] = {};

                if (!stepEl) continue;

                // Text / number / email / tel inputs
                stepEl.querySelectorAll('input[type=text], input[type=email], input[type=tel], input[type=number], textarea').forEach(function (input) {
                    if (input.name && input.value.trim() !== '') {
                        data[stepKey][input.name] = input.value.trim();
                    }
                });

                // Radio buttons (single value per name)
                const radios = {};
                stepEl.querySelectorAll('input[type=radio]:checked').forEach(function (radio) {
                    radios[radio.name] = radio.value;
                });
                Object.assign(data[stepKey], radios);

                // Checkboxes (multi-value, strip [] suffix)
                const checkboxGroups = {};
                stepEl.querySelectorAll('input[type=checkbox]:checked').forEach(function (cb) {
                    if (cb.name === 'privacyAccepted') return;
                    const key = cb.name.replace('[]', '');
                    if (!checkboxGroups[key]) checkboxGroups[key] = [];
                    checkboxGroups[key].push(cb.value);
                });
                Object.assign(data[stepKey], checkboxGroups);
            }

            return data;
        }

        // ── Submit ───────────────────────────────────────────────────────────
        const HS_FIELD_MAP = {
            contactEmail:     'email',
            contactFirstName: 'firstname',
            contactLastName:  'lastname',
            contactCompany:   'company',
            contactPhone:     'phone',
        };

        function buildSummaryText(data) {
            const lines = [];
            for (let s = 1; s <= TOTAL_STEPS - 1; s++) {
                const stepData = data['step' + s] || {};
                const entries  = Object.entries(stepData).filter(function ([, v]) {
                    return Array.isArray(v) ? v.length > 0 : v !== '' && v !== null && v !== undefined;
                });
                if (!entries.length) continue;
                lines.push('=== ' + (STEP_TITLES[s - 1] || ('Schritt ' + s)) + ' ===');
                entries.forEach(function ([key, val]) {
                    const label = FIELD_LABELS[key] || key;
                    let value = Array.isArray(val)
                        ? val.map(translateValue).join(', ')
                        : translateValue(String(val));
                    lines.push(label + ': ' + value);
                });
                lines.push('');
            }
            return lines.join('\n');
        }

        function buildHubSpotFields(data) {
            const fields = [];
            for (const stepKey of Object.keys(data)) {
                for (const [name, value] of Object.entries(data[stepKey])) {
                    if (name === 'privacyAccepted') continue;
                    const hsName  = HS_FIELD_MAP[name] || name;
                    let hsValue = Array.isArray(value)
                            ? value.map(translateValue).join(', ')
                            : translateValue(String(value));
                    fields.push({ name: hsName, value: hsValue });
                }
            }
            fields.push({ name: 'message', value: buildSummaryText(data) });
            return fields;
        }

        function submitForm() {
            btnSubmit.disabled = true;
            btnSubmit.classList.add('is-loading');

            const payload = collectFormData();

            const hutk = document.cookie.split('; ').reduce(function (acc, c) {
                const [k, v] = c.split('=');
                return k === 'hubspotutk' ? v : acc;
            }, null);

            const hsBody = {
                fields: buildHubSpotFields(payload),
                context: {
                    pageUri: window.location.href,
                    pageName: document.title,
                },
            };
            if (hutk) hsBody.context.hutk = hutk;

            fetch(HS_API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(hsBody),
            })
                .then(function (res) {
                    return res.json().then(function (body) {
                        if (res.ok) {
                            window.removeEventListener('beforeunload', onBeforeUnload);
                            form.style.display = 'none';
                            wrapper.querySelector('.roadshowForm__progress').style.display = 'none';
                            successBox.style.display = 'block';
                        } else {
                            const msg = (body.errors && body.errors[0] && body.errors[0].message)
                                || body.message
                                || ('HubSpot error ' + res.status);
                            console.error('HubSpot submission error:', body);
                            throw new Error(msg);
                        }
                    });
                })
                .catch(function (err) {
                    showError(err.message || tcs.roadshow_error_submit_general || 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.');
                    btnSubmit.disabled = false;
                    btnSubmit.classList.remove('is-loading');
                });
        }

        // ── Helpers ──────────────────────────────────────────────────────────
        function showError(msg) {
            if (!errorBox) return;
            errorBox.textContent = msg;
            errorBox.style.display = '';
        }

        function clearError() {
            if (!errorBox) return;
            errorBox.textContent = '';
            errorBox.style.display = 'none';
        }

        function escHtml(str) {
            return String(str)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;');
        }

        // ── Pre-fill from customerData ────────────────────────────────────────
        (function prefillCustomerData() {
            const el = document.getElementById('customerData');
            if (!el) return;
            let data;
            try { data = JSON.parse(el.dataset.json); } catch (e) { return; }

            const map = {
                contactCompany:   data.company_name,
                contactFirstName: data.first_name,
                contactLastName:  data.last_name,
                contactEmail:     data.mail,
            };

            Object.entries(map).forEach(function ([name, value]) {
                if (!value) return;
                const input = wrapper.querySelector('[name="' + name + '"]');
                if (input) {
                    input.value = value;
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });
        })();

        // Initial state
        updateNav();
        updateProgress();
    }
}
